<template>
  <div class="layout-bottom">
		<div class="module module-1">
			<title-bar title="充电支付概况" lineIcon="title-line-2"></title-bar>
			<div class="module-content">
				<div id="charging-payment" class="charts-box"></div>
			</div>
		</div>
		<div class="module module-2">
			<title-bar title="充电用户趋势" lineIcon="title-line-2"></title-bar>
			<div class="module-content">
				<div id="charging-user-trend" class="charts-box"></div>
			</div>
		</div>
		<div class="module module-3">
			<title-bar title="使用记录" lineIcon="title-line-2"></title-bar>
			<div class="module-content" style="padding: 8px 0">
				<div class="usage-records">
					<div class="usage-records-item" v-for="item in 10" :key="item">2024-09-07 12:00:00 用户US213624335556发起充电</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts'
import TitleBar from './title-bar.vue'

export default {
	components: { TitleBar },

	mounted() {
		this.initChargingPaymentEchart()
		this.initChargingUserTrendEchart()
	},

	methods: {
		initChargingPaymentEchart() {
			let chartDom = document.getElementById('charging-payment')
			let myChart = echarts.init(chartDom)
			let option

			setTimeout(function () {
				option = {
					color: ['#009DFF', '#FE8A00', '#00E074'],
					tooltip: {
						trigger: 'axis'
					},
					grid: {
						top: 20,
						bottom: 80
					},
					legend: {
						bottom: 20,
						textStyle: {
							color: '#fff'
						}
					},
					dataset: {
						source: [
							['date', '2012', '2013', '2014', '2015', '2016', '2017'],
							['钱包支付', 56.5, 82.1, 88.7, 70.1, 53.4, 85.1],
							['套餐卡订单', 51.1, 51.4, 55.1, 53.3, 73.8, 68.7],
							['微信支付', 40.1, 62.2, 69.5, 36.4, 45.2, 32.5]
						]
					},
					xAxis: { type: 'category' },
					yAxis: { gridIndex: 0 },
					series: [
						{
							type: 'line',
							smooth: true,
							seriesLayoutBy: 'row',
							emphasis: { focus: 'series' }
						},
						{
							type: 'line',
							smooth: true,
							seriesLayoutBy: 'row',
							emphasis: { focus: 'series' }
						},
						{
							type: 'line',
							smooth: true,
							seriesLayoutBy: 'row',
							emphasis: { focus: 'series' }
						},
					]
				}
				myChart.on('updateAxisPointer', function (event) {
					const xAxisInfo = event.axesInfo[0]
					if (xAxisInfo) {
						const dimension = xAxisInfo.value + 1
						myChart.setOption({
							series: {
								id: 'pie',
								label: {
									formatter: '{b}: {@[' + dimension + ']} ({d}%)'
								},
								encode: {
									value: dimension,
									tooltip: dimension
								}
							}
						})
					}
				})
				myChart.setOption(option)
			})

			option && myChart.setOption(option)
		}

		,
		initChargingUserTrendEchart() {
			var chartDom = document.getElementById('charging-user-trend')
			var myChart = echarts.init(chartDom)
			var option

			option = {
				color: ['#00E074'],
				grid: {
					top: 20,
					bottom: 30
				},
				tooltip: {},
				xAxis: {
					type: 'category',
					data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
				},
				yAxis: {
					type: 'value'
				},
				series: [
					{
						data: [820, 932, 901, 934, 1290, 1330, 1320],
						type: 'line',
						smooth: true
					}
				]
			}

			option && myChart.setOption(option)
		}
	}
}
</script>

<style lang="scss" scoped>
.layout-bottom {
	width: 100%;
	display: flex;
	gap: 24px;
	.module {
		flex: 1;
		&.module-3 {
			width: 400px;
			flex: none;
		}
		.module-content {
			margin-top: 15px;
			width: 100%;
			height: 256px;
			background: #141518;
			.charts-box {
				width: 100%;
				height: 256px;
			}
			.usage-records {
				padding: 0 16px;
				height: 100%;
				overflow-y: auto;
				.usage-records-item {
					color: #fff;
					font-size: 14px;
					font-weight: bold;
					padding: 8px 0;
				}
				&::-webkit-scrollbar {
					width: 1px; /* 滚动条宽度 */
				}

				&::-webkit-scrollbar-track {
					background: transparent; /* 滚动条轨道背景色 */
				}

				&::-webkit-scrollbar-thumb {
					background: green; /* 滚动条滑块背景色 */
				}
			}
		}
	}
}

</style>
